export const TOKEN = 'pk.eyJ1IjoidGFyZWtraCIsImEiOiJja29kMWIydHAwMmh5MnBvMWltejBuZGQ1In0.0c2s2DgxLFAgq6JO-DwHfw'; // Set your mapbox token here
